var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

module.exports = function (e) {
  var t = {};

  function r(l) {
    if (t[l]) return t[l].exports;
    var a = t[l] = {
      i: l,
      l: !1,
      exports: {}
    };
    return e[l].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, l) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: l
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var l = Object.create(null);
    if (r.r(l), Object.defineProperty(l, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      r.d(l, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return l;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 83);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  83: function _(e, t, r) {
    "use strict";

    var l = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = l(r(1)),
        n = l(r(2)),
        s = a(r(84)),
        u = r(4),
        i = n.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  width: ", ";\n\n  ", "\n  ", "\n"])), function (_ref) {
      var e = _ref.width;
      return e;
    }, function (_ref2) {
      var e = _ref2.theme;
      return e.wrapper;
    }, function (_ref3) {
      var e = _ref3.theme,
          t = _ref3.disabled;
      return t && e.disabled;
    }),
        c = n.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
      var e = _ref4.theme;
      return e.slot;
    }),
        d = n.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n", "\n"])), function (_ref5) {
      var e = _ref5.theme;
      return e.label;
    }),
        f = n.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n", "\n"])), function (_ref6) {
      var e = _ref6.theme;
      return e.sublabel;
    }),
        m = n.default.input(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n", "\n\n::-webkit-input-placeholder {\n  overflow: visible;\n  ", " }\n::-moz-placeholder {\n  overflow: visible;\n  ", " }\n::-ms-placeholder {\n  overflow: visible;\n  ", " }\n::placeholder {\n  overflow: visible;\n  ", " }\n"])), function (_ref7) {
      var e = _ref7.theme;
      return e.input;
    }, function (_ref8) {
      var e = _ref8.theme;
      return e.placeholder;
    }, function (_ref9) {
      var e = _ref9.theme;
      return e.placeholder;
    }, function (_ref10) {
      var e = _ref10.theme;
      return e.placeholder;
    }, function (_ref11) {
      var e = _ref11.theme;
      return e.placeholder;
    }),
        p = n.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref12) {
      var e = _ref12.theme;
      return e.error;
    });

    t.default = function (_ref13) {
      var e = _ref13.id,
          t = _ref13.name,
          _ref13$value = _ref13.value,
          r = _ref13$value === void 0 ? "" : _ref13$value,
          _ref13$type = _ref13.type,
          l = _ref13$type === void 0 ? "text" : _ref13$type,
          a = _ref13.className,
          b = _ref13.errorClassName,
          h = _ref13.labelClassName,
          v = _ref13.subLabelClassName,
          _ref13$inputClassName = _ref13.inputClassName,
          x = _ref13$inputClassName === void 0 ? "" : _ref13$inputClassName,
          y = _ref13.errorMessage,
          _ref13$errorMessages = _ref13.errorMessages,
          _ = _ref13$errorMessages === void 0 ? [] : _ref13$errorMessages,
          _ref13$onChange = _ref13.onChange,
          g = _ref13$onChange === void 0 ? function () {} : _ref13$onChange,
          _ref13$onBlur = _ref13.onBlur,
          N = _ref13$onBlur === void 0 ? function () {} : _ref13$onBlur,
          _ref13$onFocus = _ref13.onFocus,
          O = _ref13$onFocus === void 0 ? function () {} : _ref13$onFocus,
          $ = _ref13.label,
          j = _ref13.subLabel,
          _ref13$theme = _ref13.theme,
          w = _ref13$theme === void 0 ? "Basic" : _ref13$theme,
          M = _ref13.disabled,
          E = _ref13.placeholder,
          P = _ref13.rightSlot,
          _ref13$getInputRef = _ref13.getInputRef,
          S = _ref13$getInputRef === void 0 ? function () {} : _ref13$getInputRef,
          C = _objectWithoutProperties(_ref13, ["id", "name", "value", "type", "className", "errorClassName", "labelClassName", "subLabelClassName", "inputClassName", "errorMessage", "errorMessages", "onChange", "onBlur", "onFocus", "label", "subLabel", "theme", "disabled", "placeholder", "rightSlot", "getInputRef"]);

      var _o$useState = o.useState(""),
          _o$useState2 = _slicedToArray(_o$useState, 2),
          q = _o$useState2[0],
          L = _o$useState2[1],
          T = o.useRef();

      o.useEffect(function () {
        L(r);
      }, [r]);
      return o.default.createElement(n.ThemeProvider, {
        theme: u.isObject(w) ? w : s.default[w]
      }, o.default.createElement(i, {
        className: "texter " + a,
        disabled: M,
        ref: T
      }, $ && o.default.createElement(d, {
        className: "texter-label " + h
      }, $), j && o.default.createElement(f, {
        className: "texter-sublabel " + v
      }, j), o.default.createElement(m, Object.assign({
        className: "texter-input " + x,
        id: e,
        type: l,
        onChange: function onChange(e) {
          var t = e.target.value;
          L(t), g(t);
        },
        onFocus: function onFocus() {
          O(), T.current.classList.add("focused");
        },
        onBlur: function onBlur() {
          N(), T.current.classList.remove("focused");
        },
        value: q,
        name: t,
        disabled: M,
        placeholder: E,
        ref: function ref(e) {
          return S(e);
        }
      }, C)), P ? o.default.createElement(c, {
        className: "texter-slot"
      }, P()) : null, y && o.default.createElement(p, {
        className: "texter-error " + b
      }, y), _ && _.map(function (e) {
        return o.default.createElement(p, {
          className: "texter-error " + e.errorClassName
        }, e.errorMessage);
      })));
    };
  },
  84: function _(e, t) {
    e.exports = require("../../themes/Texter.theme");
  }
});